var _rect, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#424C9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.81 16.92C19.5493 16.92 21.77 14.6993 21.77 11.96C21.77 9.22067 19.5493 7 16.81 7C14.0706 7 11.85 9.22067 11.85 11.96C11.85 14.6993 14.0706 16.92 16.81 16.92Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.51 27.0004C24.6735 27.0096 24.8371 26.9836 24.9896 26.924C25.1421 26.8644 25.2799 26.7726 25.3938 26.655C25.5077 26.5373 25.5948 26.3965 25.6494 26.2421C25.704 26.0877 25.7247 25.9234 25.71 25.7604C25.07 22.0004 21.33 19.1104 16.81 19.1104C12.29 19.1104 8.55004 22.0004 7.91004 25.7604C7.89368 25.9238 7.91315 26.0888 7.9671 26.244C8.02104 26.3991 8.10817 26.5407 8.2224 26.6587C8.33663 26.7768 8.47522 26.8685 8.62852 26.9275C8.78182 26.9865 8.94614 27.0113 9.11004 27.0004H24.51Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.81 24.7302L20.37 24.9302C20.2597 24.9451 20.1473 24.9334 20.0424 24.8961C19.9374 24.8588 19.8428 24.797 19.7666 24.7158C19.6903 24.6347 19.6345 24.5365 19.6038 24.4294C19.5731 24.3223 19.5684 24.2095 19.59 24.1002L19.8901 22.6702C19.9353 22.4648 20.0396 22.2771 20.19 22.1302L23.6 18.9402C23.707 18.8449 23.8317 18.7716 23.9671 18.7245C24.1024 18.6775 24.2457 18.6576 24.3887 18.6659C24.5317 18.6743 24.6717 18.7108 24.8006 18.7733C24.9296 18.8358 25.0449 18.9231 25.14 19.0302L25.7901 19.7302C25.994 19.9345 26.1086 20.2115 26.1086 20.5002C26.1086 20.7889 25.994 21.0658 25.7901 21.2702L22.38 24.4602C22.2208 24.6044 22.0225 24.6983 21.81 24.7302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePhoto);
export default __webpack_public_path__ + "static/media/change-photo.3dc6e5016c0de7b59e766e42ceb68620.svg";
export { ForwardRef as ReactComponent };